import http from "@/api/http";

export const fetchProfile = () => {
  return http.get("/landing/parent/profile");
};

export const fetchChildren = () => {
  return http.get("/landing/parent/students");
};

export const fetchChild = (query) => {
  const { start_date, end_date, child_id } = query;
  return http.get(
    `/landing/parent/students/${child_id}?start_date=${start_date}&end_date=${end_date}`
  );
};

export const fetchActs = (childId) => {
  return http.get(`/landing/parent/students/${childId}/acts`);
};

export const fetchActInfo = (query) => {
  return http.get(
    `/landing/parent/students/${query.childId}/acts/${query.actId}`
  );
};

export const fetchApplications = () => {
  return http.get(`/landing/parent/applications`);
};

export const fetchApplicationInfo = (id) => {
  return http.get(`/landing/parent/applications/${id}`);
};

export const fetchExportChild = () => {
  return http.post("/parent/child/update");
};

export const saveProfile = (data) => {
  return http.post("/landing/parent/profile/update", data);
};

export const fetchIssuedByData = () => {
  return http.get("/reference/issued-by");
};

export const fetchDocumentType = () => {
  return http.get("/reference/document-type");
};

export const fetchSubmitAct = (query) => {
  return http.post(
    `/landing/parent/students/${query.childId}/acts/${query.actId}/agree`
  );
};

export const fetchRejectAct = (query) => {
  return http.post(
    `/landing/parent/students/${query.childId}/acts/${query.actId}/reject`,
    { comment: query.comment }
  );
};

export const fetchDeleteApplication = (id) => {
  return http.delete(`/landing/parent/applications/${id}/reject`);
};

export const applyCourse = (data) => {
  return http.post(`/landing/course/${data.courseId}/apply`, data);
};
